import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="bg-[#0a0014] font-sans min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-16 md:pt-[68px]">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
